import React from 'react';
import {imgUrl} from '../../utils/api-request';

const OrganizationPatch = ({ organization }) => {
    if (!organization) return null;

    return (
        <div className="d-flex align-items-center gap-2 p-2 bg-black bg-opacity-50 rounded" style={{ width: 'fit-content' }}>
            {organization.logo && (
                <img
                    src={imgUrl(organization.logo.imageUrl)}
                    alt={organization.name}
                    className="rounded"
                    style={{
                        width: '32px',
                        height: '32px',
                        objectFit: 'contain',
                        backgroundColor: 'white',
                        padding: '2px'
                    }}
                />
            )}
            <div>
                <div className="text-white-50" style={{ fontSize: '0.7rem', lineHeight: '1' }}>
                    Organization
                </div>
                <div className="text-white fw-bold" style={{ fontSize: '0.9rem', lineHeight: '1.2' }}>
                    {organization.name}
                </div>
            </div>
        </div>
    );
};

export default OrganizationPatch;
